import React from 'react';
import PartyMaster from './PartyMaster';

function MillFinishParties() {
  return (
    <PartyMaster
      title="Mill Finish Parties"
      modalTitle="Add Mill Finish Party"
      addButtonText="Add Mill Finish Party"
      searchPlaceholder="Search mill finish parties..."
      partyCategory="MILL_FINISH_PARTIES"
      namePlaceholder="Mill finish party name"
    />
  );
}

export default MillFinishParties;
